module.exports = __webpack_public_path__ + "static/47import-0bcded0761efd5474e81d37ea45f287c.png";